export default __webpack_public_path__ + "static/media/huma-tresfases-01.ef606ca2.jpg";